export default {
  signUpSuccess: 'Welcome to Composer\'s Companion. \n You\'ve been signed up and logged in. Click \'New Sketch\' above to start making a sketch.',
  signUpFailure: 'You have not been signed up. The email you provided may be taken, or the passwords don\'t match.',
  signInSuccess: 'Welcome to Composer\'s Companion. View your existing sketches here, or click \'New Sketch\' above to start a new one.',
  signInFailure: 'You have not been signed in. Check your email and password, then try again.',
  signOutSuccess: 'You have been signed out of Composer\'s Companion.',
  signOutFailure: 'You have been signed out of Composer\'s Companion.',
  changePasswordSuccess: 'Your password was successfully changed.',
  changePasswordFailure: 'Your password has not been changed. Ensure your old password is correctly entered.',
  createSketchSuccess: 'This sketch has been created. View, edit, or delete this new sketch here.',
  createSketchFailure: 'This sketch was not created. Please make sure all required fields are filled in and try again.',
  updateSketchSuccess: 'This sketch has been updated. Review your changes here.',
  updateSketchFailure: 'This sketch has not been updated. Please make sure all required fields are filled in and try again.',
  deleteSketchSuccess: 'Your sketch has been deleted. View your other sketches here.',
  deleteSketchFailure: 'This sketch has not been deleted. Please try again.'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js